import { Image, Box } from '@chakra-ui/react';
import { useContext } from 'react';
import MerchantContext from '../contexts/MerchantContext';

type Props = {
  boxWidth: [`${number}px`, `${number}px`, `${number}px`];
  boxHeight: [`${number}px`, `${number}px`, `${number}px`];
  org?: { logoUrl?: string };
};

const MerchantLogo = ({ boxWidth, boxHeight, org }: Props): JSX.Element => {
  const { merchant } = useContext(MerchantContext);

  return (
    <Box width={boxWidth} height={boxHeight} minWidth={'84px'}>
      <Image
        src={org ? org.logoUrl : merchant?.logoUrl}
        objectFit={'contain'}
        width={boxWidth}
        height={boxHeight}
        minWidth={'84px'}
      />
    </Box>
  );
};

export default MerchantLogo;
